import {Component, Input, ViewChild} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ApproveClientUploadRowService} from './approveClientUploadRow.service';

@Component({
  selector: 'approveClientUploadRow',
  templateUrl: './approveClientUploadRow.component.html',
  providers: [ApproveClientUploadRowService],
})
export class ApproveClientUploadRowComponent extends BaseGridNoCookieComponent<ApproveClientUploadRowService> {
  @ViewChild('approveClientUploadRow')
  public approveClientUploadRow: ModalDirective;

  /*
   *  Modal handling
   */

  @Input() id;

  public showChildModal(): void {
    this.search();
    this.approveClientUploadRow.show();
  }

  public hideChildModal(): void {
    this.approveClientUploadRow.hide();
  }

  ngOnChanges(changes) {
    this.id = changes['id'] ? changes['id'].currentValue : '';
    this.initParams = {cookieid: this.id};
  }

  public submiting: boolean = false;

  constructor(
    public gridService: ApproveClientUploadRowService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super(securityService, logger, visualsService, gridService, 'approveClientUploadRow');

    this.loadVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.getValidationMessages();
      },
    });
  }
}
